import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebar"
import {fetchserviceitemssecond} from "../../../Apiservices/Auth/servers/fetchProviderData"
import Tenthouseserviceslist from "./Tenthouse-servicelist"
function Tenthousebody() {

    const [tentservicelist, settentservicelist] = useState([])
    const [isPending, setisPending] = useState(false)
  const getlist = async()=>{
       try {
        setisPending(true)
            const response = await fetchserviceitemssecond()
            
        if(response.success){
            setisPending(false)
            console.log("settentservicelist",response)
            settentservicelist(response.data)
        }
        } catch (error) {
            console.error("got error wilie fetching tentserviceslist from fetchserviceitemssecond ")
        }
  }
    useEffect(()=>{
        getlist()
    },[])

  return (
    <div>
        <Sidebar />
            <div className="p-4">
      {isPending ? (
        <h1>Loading...</h1>
      ) : (
        <>
          <h1>Tenthouseserviceslist</h1>
          <Tenthouseserviceslist tentservicelist={tentservicelist} />
        </>
      )}
      </div>
    </div>
  )
}

export default Tenthousebody;